<div id="campaigns_detail" class="workspace">
  <div class="d-flex flex-row">
    <div class="back-btn d-flex justify-content-center align-items-center" (click)="backToPreviousStep()">
      <svg width="8px" height="20px" viewBox="0 0 19 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-12.000000, -4.000000)" fill="#000000">
            <path d="M28.949609,44.5859918 L12,24.4995264 L28.949609,4.41407071 C29.3745432,3.90817291 30.1162287,3.86071343 30.6006146,4.29996602 C31.0869498,4.74022838 31.1356807,5.50563864 30.7107466,6.00951689 L15.1061126,24.4995264 L30.7107466,42.9905456 C31.1356807,43.4944239 31.0869498,44.2598341 30.6006146,44.6990867 C30.3784013,44.9000322 30.1045332,45 29.8306651,45 C29.5051422,45 29.1815685,44.8596411 28.949609,44.5859918 Z" id="Fill-1"></path>
          </g>
        </g>
      </svg>
    </div>

    <div class="row flex-auto title">
      <div class="col-md-12 d-flex flex-row flex-wrap breadcumb-header">
        <a class="not-underline text-semi-bold-font" (click)="backToPreviousStep()">{{'group_campaigns_add.breadcumd_root' | translate}}</a>
        <span class="d-flex align-items-center ml-2 mr-2" *ngIf="campaignName !== ''">
          <svg width="14" height="13" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 16">
            <path d="M 0.43182156,15.2625 C 0.80680249,15.213584 0.96030581,14.807413 1.2100589,14.567411 3.1455498,12.255301 5.0810407,9.9431903 7.0165316,7.63108 4.9300849,5.1387667 2.8436382,2.6464533 0.75719156,0.15414 0.34255348,-0.34508242 -0.3240075,0.45648886 0.17152218,0.82533571 2.0708387,3.0939171 3.9701551,5.3624986 5.8694716,7.63108 3.9485883,9.9255533 2.0277049,12.220027 0.10682156,14.5145 c -0.24165099,0.270335 -0.048168,0.753498 0.325,0.748 z"
              fill="#95A0B1" fill-rule="nonezero"></path>
          </svg>
        </span>
        <input  class="campaign-name"
                type="text"
                actionByLevels="Basic brief"
                [wallName]="'Campaign Disabled'"
                [(ngModel)]="campaignName"
                [disabled]="isArchivedCampaign">
        <div class="campaign-status" *ngIf="campaignStatus">
          <div [ngClass]="{'campaign-active-icon': isActiveCampaign,
          'campaign-archived-icon': isArchivedCampaign}"></div>
          <span class="campaign-status-text">{{campaignStatus}}</span>
        </div>
        <div class="button-icon" *ngIf="isActiveCampaign || isArchivedCampaign">
          <a class="icon-edit"
             actionByLevels="Basic brief"
             [wallName]="'Campaign Disabled'"
             (afterChecking)="showActiveOrArchiveCampaignPopup()">
          </a>
        </div>
      </div>
      <div class="col-md-12 breadcumb-subheader">{{'campaigns.breadcumd_subtitle' | translate}}</div>
    </div>
    <span class="mx-4"><export-influencer *ngIf="campaignId" [campaignId]="campaignId" [label]="exportLabel"></export-influencer></span>
  </div>


  <div class="common-info">
    <div class="common-info-top">
      <div class="d-flex flex-row flex-auto">
        <div class="campaign-brief-container">
          <div class="campaign-brief">
            <achoo-textarea label="{{'campaigns.campaign_brief' | translate}}"
                            placeholder="{{'campaigns.campaign_brief_placeholder' | translate}}"
                            [(model)]="campaignBrief"
                            (modelChange)="markCampaignNotSaving()"
                            actionByLevels="Basic brief"
                            [wallName]="'Campaign Disabled'"
                            name="campaign_brief"
                            [disabled]="isArchivedCampaign">
            </achoo-textarea>
            <div class="brief-tooltip-container">
              <achoo-icon-tooltip [tooltipMsg]="'info_box.campaign.brief' | translate"></achoo-icon-tooltip>
            </div>
          </div>
        </div>
        <div class="campaign-keyword-container">
          <div class="mention d-flex flex-column">
            <div class="d-flex flex-column">
              <div class="d-flex flex-row align-items-center">
                <label>{{'campaigns.mentions' | translate}}</label>
                <achoo-icon-tooltip [tooltipMsg]="'info_box.campaign.brief' | translate"></achoo-icon-tooltip>
              </div>
              <achoo-chips *ngIf="!isArchivedCampaign"
                [chips]="mentions"
                [editable]="true"
                [processingChips]="processingMentions"
                (deleteItem)="onDeleteMention($event)"
              ></achoo-chips>
              <achoo-chips *ngIf="isArchivedCampaign" [chips]="mentions" [editable]="false"></achoo-chips>
            </div>
            <div>
              <achoo-text-field
                placeholder="{{'campaigns.tag_placeholder' | translate}}"
                [(model)]="currentInputMention"
                (keyDownEvent)="mentionInputKeyDown($event)"
                actionByLevels="Basic brief"
                [wallName]="'Campaign Disabled'"
                class="input-tag"
                name="campaign_keywords"
                #mentionInput
                [disabled]="isArchivedCampaign"
              ></achoo-text-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="row detail-container">
        <div class="col-12">
          <achoo-tabs [(selectedTabKey)]="tabKey" (tabClicked)="replaceTabState($event)" #mainTabs>
            <achoo-tab [tabKey]="'terms'" class="term-tab" >
              <ng-template tabHeading>
                <a placement="bottom" ngbTooltip="{{'info_box.campaign.term_condition' | translate}}">{{'campaigns.best_practices_term' | translate}}
                  <span *ngIf="selectedCampaignTerms.length">({{selectedCampaignTerms.length}})</span>
                </a>
              </ng-template>
              <div class="term-content">
                <selectable-campaign-terms [(selectableCampaignTerms)]="selectableCampaignTerms"
                                           (deleteTermEvent)="warningDeleteTerm($event)"
                                           (modifyCustomTermEvent)="showModifyTerm($event)"
                                           (selectedChange)="selectableCampaignTermsChange($event)"
                                           [isReadOnly]="isArchivedCampaign">

                </selectable-campaign-terms>
              </div>
            </achoo-tab>
            <achoo-tab [tabKey]="'influencers'" [isInfluencerTab]="true">
              <ng-template tabHeading>
                <a placement="bottom" ngbTooltip="{{'info_box.campaign.influencers' | translate}}"> {{'campaigns.influencers' | translate}}
                  <span *ngIf="campaignInfluencers.length > 0">({{campaignInfluencers.length}})</span>
                </a>
              </ng-template>
              <div class="tab-content campaign-influencers-list">
                <campaign-influencers-list isShow="!isFetchingInfluencer"
                                           [influencerList]="campaignInfluencers"
                                           [isCampaignDetails]="true"
                                           [campaignId]="campaignId">
                </campaign-influencers-list>
                <div class="campaign-influencer-loading" *ngIf="isFetchingInfluencer">
                  <achoo-loader [normalPlaceholder]="true"></achoo-loader>
                </div>
                <div class="d-flex justify-content-center tab-influencers-bottom">
                  <button class="button btn-add-more-influencer light-gray"
                          actionByLevels="Basic brief"
                          [wallName]="'Campaign Disabled'"
                          (afterChecking)="openAddInfluencerToCampaign()"
                          [disabled]="isArchivedCampaign">
                    {{'campaigns.add_influencers' | translate}}
                  </button>
                </div>
              </div>
            </achoo-tab>
            <achoo-tab class="material-tab" [tabKey]="'materials'">
              <ng-template tabHeading>
                <a placement="bottom" ngbTooltip="{{'info_box.campaign.materials' | translate}}"> {{'campaigns.campaign_materials' | translate}}
                  <span *ngIf="numberAvailabelMaterialFile > 0">({{numberAvailabelMaterialFile}})</span>
                </a>
              </ng-template>
              <div class="campaign-material d-flex flex-row flex-auto">
                <div class="additional-information-container">
                  <div class="additional-information">
                    <achoo-textarea label="{{'campaigns.campaign_material' | translate}}"
                                    placeholder="{{'campaigns.campaign_material_placeholder' | translate}}"
                                    [(model)]="campaignAdditionalInfo"
                                    (modelChange)="markCampaignNotSaving()"
                                    actionByLevels="Addtional information (files)"
                                    [wallName]="'Campaign Disabled'"
                                    name="campaign_additional_info"
                                    [disabled]="isArchivedCampaign">
                    </achoo-textarea>
                  </div>
                </div>
                <div class="upload-file-container">
                  <div class="upload-file">
                    <div class="row file-title">
                      <div class="col-md-9 col-sm-10">{{'campaigns.upload_materials' | translate}}</div>
                      <div class="col-md-3 col-sm-2 text-right text-bold-font" *ngIf="numberAvailabelMaterialFile > 0">
                        ({{ numberAvailabelMaterialFile }} {{'campaigns.uploaded' | translate}})
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 col-sm-12">
                        <upload-file [files]="materialImages"
                                     actionByLevels="Basic brief"
                                     [wallName]="'Campaign Disabled'"
                                     (fileChanged)="uploadFileChange($event)"
                                     [isReadOnly]="isArchivedCampaign">
                        </upload-file>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </achoo-tab>
          </achoo-tabs>
        </div>
      </div>
    </div>
  </div>

  <div class="group-bottombar bottombar" [ngClass]="{'open': activeBottomBar === 'active', 'collapsed': activeBottomBar === 'inactive'}">
    <div class="buttons" *ngIf="!isShowAddInfluencerToCampaignsFragment && !isShowModifyCustomTerm && !isShowAddInfluencerManuallyFragment">
      <button class="button md-button red" (click)="backToPreviousStep()">{{'common.btn.back' | translate}}</button>
      <button class="button blue" style="display: none">{{'common.btn.generate_pdf' | translate}}</button>
      <button class="button lg-button green" (click)="goToNextStep()"
              [attr.disabled]="!canCreateOrEditCampaign ? 'disabled' : null"
              *ngIf="tabKey !== 'materials'">
        {{'common.btn.save_and_next' | translate}}
      </button>
      <button class="button lg-button green"
              actionByLevels="Basic brief"
              [wallName]="'Campaign Disabled'"
              (afterChecking)="saveAndSend()"
              [attr.disabled]="(!canCreateOrEditCampaign || isSavingCampaign) ? 'disabled' : null"
              *ngIf="tabKey === 'materials'">
        {{'common.btn.save_and_send' | translate}}
      </button>
    </div>
    <div class="row full-height">
      <div class="col-md-12 col-sm-12 d-flex" *ngIf="isShowAddInfluencerToCampaignsFragment">
        <add-influencer-campaign class="d-flex flex-auto"
                                 [platformList]="supportedPlatformList"
                                 [countryList]="supportedCountryList"
                                 [isAddImmediately]="false"
                                 [campaign]="getCampaign()"
                                 [isShowAddInfluencerToCampaignsFragment]="isShowAddInfluencerToCampaignsFragment"
                                 [alreadySelectedInfluencers]="selectedInfluencerToAddCampaign"
                                 [initializeInfluencerList]="pendingInfluencerListAddToCampaign"
                                 [addInfluencerAsAccepted]="addInfluencerAsAccepted"
                                 (closeFragmentEvent)="closeAddInfluencerToCampaign($event)"
                                 (addNewInfluencerManuallyEvent)="showFragmentAddInfluencerManually($event)"
                                 (eventAddInfluencerToCampaigns)="addMoreInfluencerToCampaign($event)">
        </add-influencer-campaign>
      </div>
      <div class="col-md-12 col-sm-12 d-flex" *ngIf="isShowAddInfluencerManuallyFragment">
        <add-influencer-manually (closeFragmentAddInfluencerManually)="closeFragmentAddInfluencerManually($event)"
                                 [influencerSuggestion]="processingInfluencerSuggestion">
        </add-influencer-manually>
      </div>
      <div class="full-width col-md-12" *ngIf="isShowModifyCustomTerm">
        <campaign-custom-term-details [term]="selectedCustomTerm"
                                      (addEvent)="modifyCustomTerm($event, true)"
                                      (editEvent)="modifyCustomTerm($event, false)"
                                      (backEvent)="closeCustomTermDetailsBottomBar()">
        </campaign-custom-term-details>
      </div>
    </div>
  </div>
</div>
<achoo-popup #serviceErrorPopup
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}"
             cancelBtnLabel="{{'common.btn.close' | translate}}"
             (cancelCallback)="closeErrorMessage()">
  <span>{{serviceErrorMessage}}</span>
</achoo-popup>
<achoo-popup #confirmRemoveMentionDialog
             [isAlertPopup]="true"
              modelTitle="{{'campaigns.remove_mention.title' | translate}}"
              acceptBtnLabel="{{'campaigns.remove_mention.btn_confirm' | translate}}"
              cancelBtnLabel="{{'campaigns.remove_mention.btn_cancel' | translate}}"
              (acceptCallback)="confirmRemoveMention()"
              (cancelCallback)="closeConfirmMessageDialog()">
  <span>{{'campaigns.remove_mention.message' | translate: {mention: currentDeleteMention?.keyword} }}</span>
</achoo-popup>
<achoo-popup #ConfirmBackToCampaignListDialog
  modelTitle="{{'common.alert' | translate}}"
  acceptBtnLabel="{{'campaigns.new_campaign.back_to_list' | translate}}"
  cancelBtnLabel="{{'campaigns.new_campaign.donot_back' | translate}}"
  (acceptCallback)="backToCampaigns()"
  (cancelCallback)="closeConfirmMessageDialog()">
  <div class="d-flex flex-column flex-auto">
    <span>{{'campaigns.new_campaign.msg_back_to_list' | translate: {campaignName: campaignName} }}</span>
  </div>
</achoo-popup>
<achoo-popup #AlertAddCustomTermSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}"
             (cancelCallback)="closeConfirmMessageDialog()">
  <span>{{'campaigns.add_custom_term_success_message' | translate }}</span>
</achoo-popup>
<achoo-popup #AlertEditCustomTermSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}"
             (cancelCallback)="closeConfirmMessageDialog()">
  <span>{{'campaigns.edit_custom_term_success_message' | translate }}</span>
</achoo-popup>
<achoo-popup #WarningDeleteCustomTermDialog
             [isAlertPopup]="true"
             acceptBtnLabel="{{'common.btn.delete' | translate}}"
             cancelBtnLabel="{{'common.btn.cancel' | translate}}"
             (acceptCallback)="deleteCustomTerm()"
             (cancelCallback)="closeConfirmMessageDialog()">
  <span>{{'campaigns.term.delete_warning_message' | translate}}</span>
</achoo-popup>
<achoo-popup #CampaignStatusDialog [isSpecialPopup]="true"
             (cancelCallback)="closeConfirmMessageDialog()">
  <div class="d-flex flex-column flex-auto">
    <div class="campaign-popup-header">
        <span class="campaign-popup-header-title">{{campaignDialogHeader}}</span>
        <div [ngClass]="{'campaign-active-icon': isActiveCampaign, 'campaign-archive-icon': isArchivedCampaign}"></div>
    </div>
    <span class="campaign-popup-header-subtitle">{{campaginPopupSubtitle}}</span>
    <span class="campaign-popup-body">{{campaignDialogContent}}</span>
    <button class="button lg-button campaign-popup-button" [ngClass]="{'blue': isActiveCampaign, 'green': isArchivedCampaign}"
      (click)="changeCampaignStatus()">
      {{campaignDialogButtonText}}
    </button>
  </div>
</achoo-popup>
<achoo-popup #CampaignErrorPopup
             [isNotification]="false"
             modelTitle="{{'common.alert' | translate}}"
             [acceptBtnLabel]="'common.btn.ok_thanks' | translate"
             [cancelBtnLabel]="'common.btn.contact_support' | translate"
             (acceptCallback)="closeConfirmMessageDialog()"
             (cancelCallback)="contactSupport()"
             (closeCallback)="closeConfirmMessageDialog()">
  <span>{{campaignErrorMsg}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/campaign-detail.component.html